module.exports = __webpack_public_path__ + "img/image (15).4c699629.webp";